import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PatientList from './patientsList';
import PatientDetails from './patientDetails';
import LoadingDots from '../../shared/LoadingDots';

import {
  fetchPatients,
  selectPatients,
  selectPatientsLoading,
  selectPatientsError,
  selectSelectedPatient
} from '../../../ReduxSlices/Patients/patientSlice';

const PatientManager = ({ role, navigateTo }) => {
  const dispatch = useDispatch();
  const patients = useSelector(selectPatients);
  const loading = useSelector(selectPatientsLoading);
  const error = useSelector(selectPatientsError);
  const selectedPatient = useSelector(selectSelectedPatient);

  useEffect(() => {
  if (!patients || patients.length === 0) {
    dispatch(fetchPatients());
  }
  }, [dispatch, patients.length]);


  if (loading) return ( <LoadingDots height={10} width={30} color="#38AD3E" /> );
;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  if (!loading && patients.length === 0) {
  return <p>No patients found.</p>;
  }

  return (
    <div>
      {selectedPatient ? (
        <PatientDetails patient={selectedPatient} role={role} />
      ) : (
        <PatientList patients={patients} navigateTo={navigateTo} />
      )}
    </div>
  );
};

export default PatientManager;
